export let CategoryState = /*#__PURE__*/function (CategoryState) {
  CategoryState[CategoryState["ACTIVE"] = 1] = "ACTIVE";
  CategoryState[CategoryState["INACTIVE"] = 0] = "INACTIVE";
  return CategoryState;
}({});
export let BrandState = /*#__PURE__*/function (BrandState) {
  BrandState[BrandState["ACTIVE"] = 1] = "ACTIVE";
  BrandState[BrandState["INACTIVE"] = 0] = "INACTIVE";
  return BrandState;
}({});
export let AttributeDataType = /*#__PURE__*/function (AttributeDataType) {
  AttributeDataType["ENUM"] = "enum";
  AttributeDataType["STRING"] = "string";
  AttributeDataType["NUMBER"] = "number";
  AttributeDataType["BOOLEAN"] = "boolean";
  return AttributeDataType;
}({});
export let AttributeDisplayType = /*#__PURE__*/function (AttributeDisplayType) {
  AttributeDisplayType["SELECT"] = "select";
  AttributeDisplayType["RADIO"] = "radio";
  AttributeDisplayType["CHECKBOX"] = "checkbox";
  AttributeDisplayType["TEXT"] = "text";
  AttributeDisplayType["NUMBER"] = "number";
  return AttributeDisplayType;
}({});
export let ProductState = /*#__PURE__*/function (ProductState) {
  ProductState[ProductState["ACTIVE"] = 1] = "ACTIVE";
  ProductState[ProductState["DRAFT"] = 0] = "DRAFT";
  ProductState[ProductState["INACTIVE"] = -1] = "INACTIVE";
  return ProductState;
}({});
export let ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["MEDICINE"] = "medicine";
  ProductType["FUNCTIONAL_FOOD"] = "functional_food";
  ProductType["OTHER"] = "other";
  return ProductType;
}({});
export let ProductSaleType = /*#__PURE__*/function (ProductSaleType) {
  ProductSaleType["ONLINE"] = "online";
  ProductSaleType["STORE"] = "store";
  return ProductSaleType;
}({});
export let TrackingMode = /*#__PURE__*/function (TrackingMode) {
  TrackingMode["SERIAL"] = "serial";
  TrackingMode["QUANTITY"] = "quantity";
  return TrackingMode;
}({});
export let PricingModel = /*#__PURE__*/function (PricingModel) {
  PricingModel["DYNAMIC_MARKET"] = "DYNAMIC_MARKET";
  PricingModel["DYNAMIC_SERIAL_WEIGHT"] = "DYNAMIC_SERIAL_WEIGHT";
  PricingModel["FIXED"] = "FIXED";
  return PricingModel;
}({});
export let PriceSide = /*#__PURE__*/function (PriceSide) {
  PriceSide["SELL"] = "sell";
  PriceSide["BUY"] = "buy";
  return PriceSide;
}({});
//# sourceMappingURL=product.enum.js.map